import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollTop = () => {
  // "instant" overrides the global `scroll-behavior: smooth` so we really land at the top
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  // Disable browser's own scroll restoration so it doesn't fight us
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    scrollTop();
  }, [pathname, search]);

  return null;
}
